import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PostmethodService } from '../../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class LostJunkService {

  constructor(private ws: PostmethodService) { }

  //it is for junk
  moveToJunk(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "/lead/tcLeadMovement");
  }
  
  moveToDrop(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "/lead/lead-move-to-drop");
  }

  getMasters() {
    return this.ws.wsGet(environment.baseUrl + "/admin/master/masterRecords");
  }
}
